import { Modal } from "@heroui/react";
import type { TxHistoryLog } from "../../queries/tx_history";
import type { BridgeTx } from "../../state/types";
import { BridgeTxDetails } from "./BridgeTxDetails";
import { BridgeFailedTxDetails } from "./BridgeTxFailedDetails";
import { ShieldingTxDetails } from "./ShieldingTxDetails";
import { TransfersTxDetails } from "./TransfersTxDetails";

export function TxDetailsModal({
  isOpen,
  onClose,
  txData,
}: {
  isOpen: boolean;
  onClose: () => void;
  txData: TxHistoryLog | null;
}) {
  if (!txData) return null;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      {txData.source === "bridge" ? (
        <BridgeTxDetails txData={txData as BridgeTx} />
      ) : txData.source === "bridgeFailed" ? (
        <BridgeFailedTxDetails txData={txData} />
      ) : txData.source === "shielding" ? (
        <ShieldingTxDetails txData={txData} />
      ) : (
        <TransfersTxDetails txData={txData} />
      )}
    </Modal>
  );
}
